import styled from 'styled-components';
import {
  IC_PENDING,
  IC_VERIFIED,
  IC_INCOMPLETE,
  IC_ORDERCLOCK,
  IC_ORDERCLOCK_CHOCOLATE,
  IC_CANCEL,
  IC_PENDING_RED,
  IC_REJECT_CIRCLE,
} from '../../Assets/images';

export const VerificationStatusStyled = styled.div`
  .verification-status {
    font-size: 14px;
    line-height: 18px;
    border-radius: 6px;
    height: 30px;
    padding: 5px 10px;
    margin-top: 8px;
    width: fit-content;
    text-transform: capitalize;
    color: ${(props) => props.theme.text.pending};
    background: ${(props) => props.theme.text.pending}20;
    &.pending-wo-image {
      color: ${(props) => props.theme.text.pending};
      background: ${(props) => props.theme.text.pending}20;
      margin-top: 0px;
    }
    &.verified-wo-image {
      color: ${(props) => props.theme.green.dark};
      background: ${(props) => props.theme.green.medium};
      margin-top: 0px;
    }
    &.incomplete-wo-image {
      color: ${(props) => props.theme.color.red};
      background: ${(props) => props.theme.color.red}20;
      margin-top: 0px;
    }
    white-space: nowrap;

    &.order-confirmed-wo-image {
      color: ${(props) => props.theme.blue.light};
      background: ${(props) => props.theme.blue.iconBg};
      margin-top: 0px;
    }
    &.picked-up-wo-image {
      color: ${(props) => props.theme.mandalay.dark};
      background: ${(props) => props.theme.mandalay.iconBg};
      margin-top: 0px;
    }
    &.picked-up-scheduled-wo-image {
      color: ${(props) => props.theme.grey.dark};
      background: ${(props) => props.theme.grey.iconBg};
      margin-top: 0px;
    }

    &.rejected {
      color: ${(props) => props.theme.color.red};
      background:${(props) => props.theme.verification.red.off} url(${IC_REJECT_CIRCLE.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;
    }

    &.pending {
      color: ${(props) => props.theme.text.pending};
      background: ${(props) => props.theme.verification.orange.off} url(${IC_PENDING.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;
    }
    &.under {
      color: ${(props) => props.theme.text.pending};
      background: ${(props) => props.theme.verification.orange.off} url(${IC_PENDING.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;
    }
    &.verified {
      color: ${(props) => props.theme.green.dark};
      background: ${(props) => props.theme.green.off} url(${IC_VERIFIED.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;

      &.no_bg_color {
        margin: 0;
        background: transparent url(${IC_VERIFIED.src}) no-repeat 0px 6px / 17px;
        padding-left: 22px;
      }
    }
    &.incomplete {
      color: ${(props) => props.theme.color.red};
      background: ${(props) => props.theme.verification.red.off} url(${IC_INCOMPLETE.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;

      &.no_bg_color {
        margin: 0;
        background: transparent url(${IC_INCOMPLETE.src}) no-repeat 0px 6px / 17px;
        padding-left: 22px;
      }
    }
    &.process {
      color: ${(props) => props.theme.text.pending};
      background: ${(props) => props.theme.verification.orange.off} url(${IC_ORDERCLOCK.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;
    }
    &.Received {
      color: ${(props) => props.theme.blue.dark};
      background: ${(props) => props.theme.blue.iconBg} no-repeat 10px 7px / 15px;
    }
    &.cancel {
      color: ${(props) => props.theme.verification.red.main};
      background: ${(props) => props.theme.verification.red.off} url(${IC_CANCEL.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;
    }
    &.expired {
      color: ${(props) => props.theme.verification.red.main};
      background: ${(props) => props.theme.verification.red.off} url(${IC_PENDING_RED.src}) no-repeat 10px 7px / 15px;
      padding-left: 34px;
    }
    &.picked-up {
      color: ${(props) => props.theme.mandalay.dark};
      background: ${(props) => props.theme.mandalay.iconBg} url(${IC_ORDERCLOCK_CHOCOLATE.src}) no-repeat 10px 7px /
        15px;
      padding-left: 34px;
    }
  }
  &.noIcon {
    .verification-status {
      &.pending {
        background: ${(props) => props.theme.text.pending}20;
        padding-left: 10px;
        background-image: none;
      }

      &.verified {
        background: ${(props) => props.theme.green.off};
        padding-left: 10px;
        background-image: none;
      }

      &.incomplete {
        background: ${(props) => props.theme.color.red}20;
        padding-left: 10px;
        background-image: none;
      }

      &.process {
        background: ${(props) => props.theme.verification.orange.off};
        background-image: none;
        padding-left: 10px;
      }

      &.Processing {
        background: ${(props) => props.theme.verification.orange.off};
        background-image: none;
        padding-left: 10px;
        color: ${(props) => props.theme.text.pending};
      }

      &.cancel {
        background: ${(props) => props.theme.color.red}20;
        padding-left: 10px;
        background-image: none;
      }
      &.Received {
        background: ${(props) => props.theme.blue.iconBg};
        padding-left: 10px;
        background-image: none;
        color: ${(props) => props.theme.blue.dark};
      }
      &.outForDelivery {
        text-transform: none;
        background: ${(props) => props.theme.green.off};
        color: ${(props) => props.theme.green.dark};
        padding: 4px;
        margin-top: 8px;
      }
      &.Delivered {
        text-transform: none;
        background: ${(props) => props.theme.green.off};
        color: ${(props) => props.theme.green.dark};
        padding: 4px;
        margin-top: 8px;
      }
    }
    &.mr {
      margin-bottom: 8px;
    }
  }
`;
